import { randFullName, randUuid } from '@ngneat/falso'
import { jwtDecode } from 'jwt-decode'

class JWT {
  /**
   * WARNING: This method should only be used for testing purposes.
   */
  static generateToken(expirationDate: Date): string {
    const base64UrlEncode = (obj: Record<string, unknown>): string => {
      return Buffer.from(JSON.stringify(obj))
        .toString('base64')
        .replace(/=+$/, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
    }

    const header = { alg: 'none', typ: 'JWT' }
    const payload = {
      id: randUuid(),
      name: randFullName(),
      exp: Math.floor(expirationDate.getTime() / 1000)
    }

    return `${base64UrlEncode(header)}.${base64UrlEncode(payload)}.`
  }

  static decode(token: string) {
    try {
      return jwtDecode(token)
    } catch {
      return null
    }
  }

  static isExpired(token?: string | null) {
    if (!token) {
      return true
    }

    try {
      const decodedToken = jwtDecode(token)
      const currentTime = Date.now() / 1000

      return Boolean(decodedToken?.exp && decodedToken.exp < currentTime)
    } catch {
      return true
    }
  }
}

export default JWT
